import { useParams,useLocation } from "react-router";
import ReglementsItemComponent from "../../components/Reglements/ReglementsItem";
import { useReglementsByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState } from "../../types/QueryParameters";


function ReglementsItem(){
    const location = useLocation();
    const state = location.state as LocationState | undefined;
    const params = useParams();
    const { data:reglement, error, isLoading } = useReglementsByIdQuery(params.id??"0");
    const {translate}=useTrads();
    
    return (

        
        error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        reglement &&
        <>
          {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_reglement_update')}</p>}
          <ReglementsItemComponent reglement={reglement}  />
        
        </>

    );
}
export default ReglementsItem;